import React, {useState} from 'react';

const {forwardRef, useImperativeHandle} = React;

import {useTranslation} from "react-i18next";
import {Modal, OverlayTrigger, Tooltip} from 'react-bootstrap'
import Auxiliary from "../../hoc/Auxiliary";
import Currency from "../Utils/Number/Currency";
import DateFormated from "../Utils/Date/Date";
import Alert from "../UI/Alerts/Alert";

import CardsList from "../Profile/SavedPaymentMethods/Cards/List";
import Creditcards from "../Utils/Creditcards/Creditcards";

const PaymentPopup = forwardRef((props, ref) => {
    const [show, setShow] = useState(false);
    const [confirmationNumber, setConfirmationNumber] = useState(false);
    const [error, setError] = useState(false);
    const [warning, setWarning] = useState(false);
    const [success, setSuccess] = useState(false);
    const [cardUsed, setCardUsed] = useState(false);
    const [alert, setAlert] = useState({});
    const [loadingForm, setLoadingForm] = useState(true);
    const handleClose = () => setShow(false);

    const handleShow = (e) => {
        if (e !== undefined)
            e.preventDefault();

        if (!props.disable_button)
            setShow(true);
    }

    useImperativeHandle(ref, () => ({
        closeModal() {
            handleClose()
        }
    }));

    const resetMessages = () => {
        setAlert({});
        setConfirmationNumber(false);
    }
    const handleShowMessage = (type, message) => {
        resetMessages();

        $('.modal-body').animate({scrollTop: 0});

        if (type === 'error')
            setAlert({type: 'danger', item: {type: 'top', text: message}});
        else if (type === 'warning')
            setAlert({type: 'warning', item: {type: 'top', text: message}});
        else if (type === 'success')
            setAlert({type: 'success', item: {type: 'top', text: message}});
        else if (type === 'confirmation')
            setConfirmationNumber(message);
    }

    const {t} = useTranslation();
    let modal_content;

    const paymentDone = confirmationNumber && cardUsed

    const title = (paymentDone) ? t('popup.confirmation') : props.modal_title;

    if (props.modal_func === 'payment') {

        const cardListPermissions = {select: true, delete: true, pay: true};


        modal_content = <Modal.Body id={'modalBody'}>
            {(paymentDone ?
                <div className="row">
                    <div id="payment-success" className="message message--success">
                        <div className="message__icon">
                            <i className="fas fa-check-circle"></i>
                        </div>
                        <div className="message__content">
                            <div>
                                <span>{t('payment.success_message.line1')}</span>
                                <span
                                    className="p--c-black">{' '}{t('payment.success_message.line2', {confirmation_number: confirmationNumber})}</span>
                                <br/>
                                <span className="p--c-black">{t('payment.success_message.line3')}</span>
                            </div>
                        </div>
                    </div>
                </div> : null)}
            {(alert != {} ? <div>
                    <div className={"messages"}>
                        <Alert type={alert.type} item={alert.item}/>
                    </div>
                </div>
                : null)}
            <div className="row">
                <div className="col-sm-6 mb-3 mb-sm-0">
                    <p>
                        <strong>{props.customer_data.subAccountName}</strong><br/>
                        {(props.customer_data.address.addressLine1) &&
                        <span>{props.customer_data.address.addressLine1}<br/></span>}
                        {(props.customer_data.address.addressLine2) &&
                        <span>{props.customer_data.address.addressLine2}<br/></span>}
                        {(props.customer_data.address.city) && <span>{props.customer_data.address.city}</span>}
                        {(props.customer_data.address.stateOrProvinceCode) &&
                        <span>,&nbsp;{props.customer_data.address.stateOrProvinceCode}<br/></span>}
                        {props.customer_data.address.postalCode}<br/>
                        <strong>#{props.customer_data.subAccountCode}</strong>
                    </p>
                </div>
                <div className="col-sm-6 mb-3 mb-sm-0">
                    <p>
                        {t("popup.amounttopay")}<br/>
                        <span className="price">
                            <Currency
                                value={props.amount}/>
                            </span>
                    </p>
                    {
                        props.customer_data.totalBalance.value !== 0  && props.ajustement_account !== undefined &&
                            props.customer_data.subAccountDisplayMode.code !== "A" &&
                        <div className="p"><OverlayTrigger placement="top"
                                                           overlay={<Tooltip id="tooltip-top">
                                                               {t('account_ajustement.tooltip')}
                                                           </Tooltip>}>
                            <div className="btn-info-tooltip btn-info-tooltip--flowtext btn-info-tooltip--green"><i
                                className="far fa-info-circle"></i>
                                <div className="btn-info-tooltip__text">
                                    {t('account_ajustement.ajustement')}&nbsp;<Currency
                                    value={props.ajustement_account.totalBalance.value}/>&nbsp;{t('account_ajustement.ajustementend')}
                                </div>
                            </div>
                        </OverlayTrigger></div>
                    }

                    {props.customer_data.lastStatementDueDate &&
                    <p>
                        {t("popup.datedue")}<br/>
                        <strong>
                            <DateFormated date={props.customer_data.lastStatementDueDate}/>
                        </strong>
                    </p>
                    }
                </div>
            </div>
            {!paymentDone ?
                <div className="row">
                    <div className="col-12">
                        <CardsList
                            from={'popup'}
                            can={cardListPermissions}
                            amount={props.amount}
                            sub_account={props.customer_data}
                            handleShowMessage={handleShowMessage}
                            resetMessages={resetMessages}
                            setCardUsed={setCardUsed}/>
                    </div>
                </div>
                :
                <React.Fragment>
                    <div className="row row--bordered">
                        <div className="col-sm-6">
                            {t("popup.modeofpayment")}<br/>
                            <strong><Creditcards type={cardUsed.card_type}/>{' '}{t('payment.card_resume', {
                                type: t('payment.card_type.' + cardUsed.card_type),
                                last4digits: cardUsed.card_ending
                            })}</strong>
                        </div>
                        <div className="col-sm-6">
                            {t("popup.dateofpayment")}<br/>
                            <strong><DateFormated date={Date.now()}/></strong>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12 d-flex justify-content-end">
                            <button className="btn btn--raised btn--raised--red btn--fs-12" style={{width: "164px"}}
                                    onClick={handleClose}>{t("popup.close")}</button>
                        </div>
                    </div>
                </React.Fragment>
            }

        </Modal.Body>

    } else {
        modal_content = <Modal.Body>
            {props.modal_content}
        </Modal.Body>
    }


    return (
        <Auxiliary>

            {!props.hide_button ?
                <Auxiliary>
                    <div className={props.button_tooltip ? 'tooltip-hovering' : ''}>
                        {props.button_tooltip ? <span className="error-tooltip">{props.button_tooltip}</span> : null}

                        {props.btn_type === 'link' ?
                            <a className={"modalButton link link--red link--accent link--fs-14 " + (props.disable_button ? 'disabled' : '')}
                               disabled={props.disable_button ? true : false} onClick={(e) => handleShow(e)}
                               href={'#'}>
                                {props.btn_title}
                            </a>
                            :
                            <button
                                className={"btn btn--outline btn--fs-12 " + (props.disable_button ? 'disabled' : '')}
                                disabled={props.disable_button ? true : false} onClick={handleShow}>
                                <b><i className="fas fa-file-invoice-dollar"></i>&nbsp;&nbsp;{props.btn_title}</b>
                            </button>}
                    </div>

                    {!props.disable_button ?
                        <Modal show={show}
                               onHide={handleClose}
                               keyboard={true}
                               animation={false}
                               dialogClassName="ultimate-modal"
                               backdrop="static"
                        >
                            <Modal.Header closeButton>
                                <h3 className="headline headline--c-white headline--block headline--margin--0 text-uppercase headline--weight--extra-bold headline--fs-22">{title}</h3>
                            </Modal.Header>
                            {modal_content}

                        </Modal> : null}
                </Auxiliary> : null}
        </Auxiliary>
    )

});

export default PaymentPopup;
